import * as React from 'react';
import { Image, StyleSheet } from 'react-native';
import { Button } from 'react-native-elements';
import Container from '../components/Container';
import Separator from '../components/Separator';
import { View } from '../components/Themed';
import { getAuthToken, getRequest } from '../utils/request';

export default function Preview({ route, navigation }) {
  const image = route.params.image;
  const name = route.params.name;

  function onGenerate() {
    getAuthToken((token: string) => {
      getRequest("https://api.avatarsdk.com/avatars/", token, (resp: any) => {
        console.log(resp);
        const namesCount = resp.map(avatar => avatar.name).filter(n => n.includes(name)).length;
        var code = name;
        if (namesCount == 0) {
            code = name + "00";
        } else if (namesCount < 10) {
            code = name + "0" + namesCount;
        } else {
            code = `${name}${namesCount}`;
        }

        navigation.navigate('Result', {name: code, image: image})
      });
    });
  }

  return (
    <Container>
      <Image style={styles.image} source={{ uri: image }} resizeMode="contain" />
      <Separator />
      <View style={styles.buttons}>
          <Button buttonStyle={styles.button} title="Générer mon avatar / Generate my avatar" onPress={onGenerate} />
          <Button buttonStyle={styles.button} type="outline" title="Réessayer / Try again" onPress={() => navigation.navigate('Picture')} />
      </View>
    </Container>
  );
}

const styles = StyleSheet.create({
  buttons: {
    display: "flex",
    flexDirection: "row"
  },
  button: {
    margin: 10
  },
  image: {
      width: "80%",
      height: "70%",
      maxWidth: "800px",
      borderRadius: 8
  }
});
